import {
  UPDATE_SEARCH_KEYWORD,
  UPDATE_SEARCH_STATUS,
  UpdateSearchActions,
  Torrent,
  FETCH_TORRENTS_PENDING,
  FETCH_TORRENTS_SUCCESS,
  FETCH_TORRENTS_ERROR,
  TorrentActions,
  TorrentStatus,
  TOGGLE_ADDING_DIALOG,
  AddingDialogActions,
  TOGGLE_ADDING_PENDING,
  ADD_TORRENT_ERROR,
  ADD_TORRENT_SUCCESS,
  RESET_ADDING_STATE,
  SET_ACTIVE_TORRENT,
  SET_SELECTED_TORRENTS,
  SET_TOAST_MSG,
  ToastActions,
  ToastVariant,
  TOGGLE_DELETING_PENDING,
  SET_SETTING_PENDING,
  SET_SETTINGS,
  SettingActions,
  TOGGLE_TORRENT_PENDING,
  TorrentFile,
  SET_ACTIVE_TORRENT_FILES,
  TorrentNode,
  QueueItem,
  SET_ARCHIVE_QUEUE,
  TOGGLE_ARCHIVE_PENDING,
  Settings,
  SYNC_STATS,
  DownloadStat,
  SYNC_TORRENT_STATS,
  TorrentStatsDiff,
  Tracker,
  SET_ACTIVE_TORRENT_TRACKERS,
  SET_TORRENTS_COUNT,
  SET_LOGIN
} from "../types";

/**
 * Setting Actions
 */

export function setSettingPending(pending: boolean): SettingActions {
  return {
    type: SET_SETTING_PENDING,
    pending
  };
}

export function setSettings(settings: Settings): SettingActions {
  return {
    type: SET_SETTINGS,
    settings
  };
}

/**
 * Notification Actions
 */

export function setToastMsg(
  message?: string,
  variant?: ToastVariant
): ToastActions {
  return {
    type: SET_TOAST_MSG,
    message,
    variant
  };
}

/**
 * Search Actions
 */

export function updateSearchKeyword(keyword?: string): UpdateSearchActions {
  return {
    type: UPDATE_SEARCH_KEYWORD,
    keyword
  };
}

export function updateSearchStatus(status?: TorrentStatus): UpdateSearchActions {
  return {
    type: UPDATE_SEARCH_STATUS,
    status
  };
}

/**
 * Torrent Actions
 */

export function fetchTorrentPending(): { type: string } {
  return {
    type: FETCH_TORRENTS_PENDING
  };
}

export function fetchTorrentSuccess(
  torrents: Array<Torrent>,
  append = false
): TorrentActions {
  return {
    type: FETCH_TORRENTS_SUCCESS,
    torrents,
    append
  };
}

export function fetchTorrentError(error: Error): TorrentActions {
  return {
    type: FETCH_TORRENTS_ERROR,
    error: {
      name: error.name,
      message: error.message
    }
  };
}

export function setTorrentCount(count: number): TorrentActions {
  return {
    type: SET_TORRENTS_COUNT,
    count
  };
}

export function setActiveTorrent(torrent?: Torrent): TorrentActions {
  return {
    type: SET_ACTIVE_TORRENT,
    torrent
  };
}

export function setActiveTorrentFiles(
  id: number,
  files: TorrentFile[],
  nodes: TorrentNode[]
): TorrentActions {
  return {
    type: SET_ACTIVE_TORRENT_FILES,
    files,
    nodes,
    id
  };
}

export function setActiveTorrentTrackers(
  id: number,
  trackers: Tracker[]
): TorrentActions {
  return {
    type: SET_ACTIVE_TORRENT_TRACKERS,
    trackers,
    id
  };
}

export function setSelectedTorrents(torrentIds: number[]): TorrentActions {
  return {
    type: SET_SELECTED_TORRENTS,
    torrentIds
  };
}

export function toggleTorrentPending(
  torrentId: number,
  pending: boolean
): TorrentActions {
  return {
    type: TOGGLE_TORRENT_PENDING,
    torrentId,
    pending
  };
}

export function syncTorrentStats(diff: TorrentStatsDiff): TorrentActions {
  return {
    type: SYNC_TORRENT_STATS,
    diff
  };
}

/**
 * Adding Actions
 */

export function toggleAddingDialog(show: boolean): AddingDialogActions {
  return {
    type: TOGGLE_ADDING_DIALOG,
    show
  };
}

export function toggleAddingPending(pending: boolean): AddingDialogActions {
  return {
    type: TOGGLE_ADDING_PENDING,
    pending
  };
}

export function addTorrentSuccess(added: Torrent): AddingDialogActions {
  return {
    type: ADD_TORRENT_SUCCESS,
    added
  };
}

export function addTorrentError(error: Error): AddingDialogActions {
  return {
    type: ADD_TORRENT_ERROR,
    error: {
      name: error.name,
      message: error.message
    }
  };
}

export function resetAddingState(): AddingDialogActions {
  return {
    type: RESET_ADDING_STATE
  };
}

/**
 * Deleting Actions
 */

export function toggleDeletingPending(pending: boolean) {
  return {
    type: TOGGLE_DELETING_PENDING,
    pending
  };
}

/**
 * Archving actions
 */

export function toggleArchivePending(pending: boolean) {
  return {
    type: TOGGLE_ARCHIVE_PENDING,
    pending
  };
}

export function setArchiveQueue(queue: QueueItem[]) {
  return {
    type: SET_ARCHIVE_QUEUE,
    queue
  };
}

/**
 * Stat actions
 */
export function syncDownloadStat(stat: DownloadStat) {
  return {
    type: SYNC_STATS,
    stat
  };
}


/**
 * Login actions
 */
export function setLogin(login: boolean) {
  return {
    type: SET_LOGIN,
    login
  }
}